import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import "./GroupsDetail.css";
import { grp_member5, img_placehlder, subscription_icon, } from "../../../assets";
import { CiLock } from "react-icons/ci";
import { RiShareForwardLine } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import { Dropdown } from "react-bootstrap";
import { IoArrowBackOutline, IoChatboxEllipsesOutline } from "react-icons/io5";
import { IoVideocamOutline } from "react-icons/io5";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FaAngleDown, FaArrowLeft, FaPlus, FaPlusCircle, FaRegCommentDots } from "react-icons/fa";
import { deleteGroupApi, groupDetailApi, joinGroupApi } from "../../../services/groups";
import { toastMessage } from "../../../utils/toastMessage";
import { useSelector } from "react-redux";
import { tabHandler } from "../../../utils/regexValidation";
import { groupKey } from "../../../utils/staticData";
import Feeds from "./groupDetailSubModules/Feeds";
import ConnectedGroup from "./groupDetailSubModules/ConnectedGroup";
import DeleteModal from "../../../Components/modals/DeleteModal";
import { collectIds, getParentIds } from "../../../utils/commonHelper";
import { getCheckLiveApi, groupMemberListApi } from "../../../services/groupMember";
import GroupMemberList from "./groupRequestDrawer/GroupMemberList";
import GroupSetting from "./groupRequestDrawer/GroupSetting";
import { isCurrentTimeInRange } from "../../../utils/dateTimeFormat";
import { encryptData } from "../../../utils/dataCipher";
import ReportSideDrawer from "../../../Components/sideDrower/ReportSideDrawer";
import SubscriptionPlan from "./subscription/SubscriptionPlan";
import { handleCopy } from "../../../utils/copyClipboard";
import { Button, LoadingButton } from "../../../Components/header/form";
import ExitGroup from "./memberGroup/ExitGroup";
import { groupDetailsLink } from "../../../utils/shareLink";

const GroupsDetail = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const [showReportModal, setShowReportModal] = useState(false);
  const [removeMemberModal, setRemoveMemberModal] = useState(false);
  const { liveDetail } = useSelector((state) => state?.liveDetail);
  const [groupSettingModal, setGroupSettingModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [memberList, setMemberList] = useState([]);
  const [memberType, setMemberType] = useState("member");
  const [joinGroupRequestModal, setJoinGroupRequestModal] = useState(false);
  const [loading, setLoading] = useState(false);
  let key = searchParam.get("key") || "feed";
  const { groupId } = useParams();
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [groupDetail, setGroupDetail] = useState({});
  const [tab, setTab] = useState("Feeds");
  const navigate = useNavigate();
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [joinLoading, setJoinLoading] = useState(false)
  const [exitGroupModal, setExitGroupModal] = useState(false)
  const [newRequest, setNewRequest] = useState(false)
  // const [selectedId, setSelectedId] = useState('')
  // console.log('newRequest', newRequest)
  //--------handle-group-member-modal-------------
  const handleViewMember = (id, member) => {
    const isMember = member?.some((data) => data?._user?._id === showAuth?._id)
    if (id === showAuth?._id && isMember) {
      setJoinGroupRequestModal(true)
      setNewRequest(false)
    }
    else if (id !== showAuth?._id && isMember) {
      setJoinGroupRequestModal(true)
      setNewRequest(true)
    }
  }
  //----------here-check-more-than-one-category---to-check-level-wise-------------
  const getParentCategories = (group) => {
    if (!group || typeof group !== "object") return [];

    let categories = [];
    let currentParent = group._parent;

    while (currentParent && typeof currentParent === "object") {
      if (currentParent.categoryName) {
        categories.unshift(currentParent.categoryName);
      }
      currentParent = currentParent._parent || null;
    }

    return categories.length > 0 ? categories : [];
  };

  // console.log('getParentCategories(groupDetails', getParentCategories(groupDetail))
  //--------navigate-chat-message-------------
  const navigateChat = (chatId) => {
    // console.log('chatId in side navigate', chatId)
    navigate(`/dashboard/message/group/${chatId}`)
  }
  //-------handle-exit-group----------
  const handleExitGroup = () => {
    setExitGroupModal(true)
  }

  const renderHtml = (status, chatId) => {
    switch (status) {
      case "ACCEPTED":
        return (
          <button onClick={() => navigateChat(chatId)} type="button" className="chat_member">
            <IoChatboxEllipsesOutline />
            &nbsp; Chat
          </button>
        );
      case "REQUESTED":
        return (
          <Button isDisabled={true} className="join_button">
            Request Sent
          </Button>
        );
      default:
        return null; // Handle cases where the status doesn't match
    }
  };

  //--------------join-group-handler-----------------
  const joinGroupHandler = async (_id) => {
    try {
      setJoinLoading(true);
      const { data } = await joinGroupApi({ _id });
      const { success, message, data: response } = data;
      if (success) {
        getGroupDetail()
      }
      toastMessage(message, success ? 'success' : "error", "joinHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setJoinLoading(false);
    }
  };
  // console.log('live', typeof (live))
  const getGroupDetail = async () => {
    try {
      const { data } = await groupDetailApi({ _id: groupId });
      const { success, message, data: response } = data;
      if (success) {
        setGroupDetail(response);
      } else {
        toastMessage(message, "error", "getGroupDetail");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  // Delete Group
  const deleteGroupHandler = async () => {
    try {
      setLoading(true);
      const { data } = await deleteGroupApi({ _id: groupId });
      const { success, message } = data;
      // console.log(success, message, "Success", "Message");
      if (success) {
        toastMessage(message, "success", "deleteGroupHandler");
        setDeleteModal(false);
        navigate("/dashboard/group");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  //Member List
  const fetchGroupMemberList = async () => {
    try {
      const { data } = await groupMemberListApi({
        _id: groupId,
        status: memberType === "memberRequest" ? "request" : "",
      });
      const { success, message, data: response } = data;

      if (success) {
        setMemberList(response);
        // console.log(collectIds(response), "Get Parents Ids");
      } else {
        toastMessage(message, "error", "getGroupDetail");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  useEffect(() => {
    getGroupDetail();
    // getLiveCheck()
  }, [groupId]);

  useEffect(() => {
    fetchGroupMemberList();
  }, [memberType]);

  // console.log(memberList, "memberList");

  const liveHandler = () => {
    if (liveDetail?._id) {
      if (!groupDetail?.live || Object.keys(groupDetail?.live).length === 0) {
        navigate(
          `/dashboard/overview/go-live?info=${encryptData(groupDetail)}`
        );
      } else if (
        isCurrentTimeInRange({
          startDateTime: groupDetail?.live?.startDateTime,
          endDateTime: groupDetail?.live?.endDateTime,
        })
      ) {
        window.open(groupDetail?.live?.event?.meetLink, "_blank");
      } else if (
        !isCurrentTimeInRange({
          startDateTime: groupDetail?.live?.startDateTime,
          endDateTime: groupDetail?.live?.endDateTime,
        })
      ) {
        navigate(
          `/dashboard/overview/go-live?info=${encryptData(groupDetail)}`
        );
      }
    } else {
      toastMessage(
        "Please connect your account with google meet",
        "error",
        "liveHandler"
      );
    }
  };
  return (
    <>
      {/* Group_ Detail_Header_Start */}
      <DashboardHeader title={"Groups"} />
      <div className="GroupPage group_details">
        <div className="grp_Navbar">
          <nav>
            <ul className="_breadcrumb">
              <li className="__breadcrumb_group">
                {/* <Link to={-1}>Groups</Link> */}
                <Link to={-1}>
                  <FaArrowLeft className="backarrow_grp_detail" />
                </Link>
              </li>
              <li>
                <span>Group Details</span>
              </li>
            </ul>
          </nav>

          <div className="gro_Navbar_search">
            {/* <button className="create_group_btns">
              Create Group
              <div className="icon">+</div>
            </button> */}
            {/* {groupDetail?.level === 4 || (
              <Link
                to={`/dashboard/group/create-level-group/${groupId}`}
                className="create_group_btns"
              >
                Create Group
                <div className="icon">+</div>
              </Link>
            )} */}

            {/* Create Feeds */}
            {/* <Dropdown.Item href="#/action-1">Report</Dropdown.Item> */}
            <div className="three_dot_icon three_dot_cstm">
              <Dropdown>
                <Dropdown.Toggle id="dropdown-basic">
                  Create <FaPlusCircle />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {/* {collectIds(groupDetail).includes(showAuth?._id) && ( */}
                  <>
                    {groupDetail?.level === 4 || (
                      <Dropdown.Item
                        as={Link}
                        to={
                          groupDetail?.level >= 1
                            ? `/dashboard/group/create-level-group/${groupId}/${groupDetail?.admin?._user}`
                            : `/dashboard/group/create-group/${groupId}`
                        }
                      >
                        Create Group
                      </Dropdown.Item>
                    )}

                    <Dropdown.Item
                      as={Link}
                      to={`/dashboard/group/create-feed/${groupId}`}
                    >
                      Create Feed
                    </Dropdown.Item>
                  </>
                  {/* )} */}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        {groupDetail?.settings?.showGroupTag &&
          getParentCategories(groupDetail)?.map((category, index) => (
            <span key={index} className="badge_grp health">{category}</span>
          ))}
        <span className="badge_grp health">{groupDetail?.categoryName}</span>



        <div className="groupdetil_container">
          <div className="actions">
            <div className="title">
              <h2>{groupDetail?.name}</h2>

            </div>
            <div className="actions_icons">
              {groupDetail?.type === 'SUBSCRIPTION' && (//&& groupDetail?.subscription?.status !== 'ACTIVE' 
                <button type="button" className="share_icon">
                  <img
                    // onClick={() => setSubscriptionModal(true)} 
                    src={subscription_icon} alt="" />
                </button>
              )}

              {groupDetail?.type === 'PRIVATE' &&
                <button type="button" className="lock_icon">
                  <CiLock />
                </button>
              }
              <button type="button" onClick={() => handleCopy(`${groupDetailsLink}${groupDetail?._id}`)} className="share_icon">
                <RiShareForwardLine />
              </button>

              <div className="three_dot_icon">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <BsThreeDots />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {collectIds(groupDetail).includes(showAuth?._id) ? (
                      <>
                        <Dropdown.Item
                          as={Link}
                          to={
                            groupDetail?.level > 1
                              ? `/dashboard/group/edit-level-group/${groupId}`
                              : `/dashboard/group/edit-group/${groupId}`
                          }
                        >
                          Edit
                        </Dropdown.Item>

                        <Dropdown.Item
                          as={Link}
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setDeleteModal(true);
                          }}
                        >
                          Delete
                        </Dropdown.Item>

                        <Dropdown.Item
                          as={Link}
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setGroupSettingModal(true);
                          }}
                        >
                          Group Setting
                        </Dropdown.Item>
                      </>
                    ) : groupDetail?.members?.some(member => member._user?._id === showAuth?._id) ? (
                      <>
                        <Dropdown.Item
                          as={Link}
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowReportModal(true);
                          }}
                        >
                          Report
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to="#"
                          onClick={() => handleExitGroup(groupDetail)}
                        >
                          Exit Group
                        </Dropdown.Item>
                      </>
                    ) : (
                      // ----no-admin-and-no-join-in-group-then-show-report------------------------
                      <Dropdown.Item
                        as={Link}
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowReportModal(true);
                        }}
                      >
                        Report
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

            </div>
          </div>

          <div className="image-section">
            <img src={groupDetail?.coverImage} alt="Health Hub Yoga Pose" />
          </div>
          <div className="content">
            <div className="card_footer_grp">
              <div
                className="members"
                onClick={() => handleViewMember(groupDetail?.admin?._user, groupDetail?.members)}
              >
                {groupDetail?.members?.slice(0, 3).map((data, ind) => (
                  <img
                    key={ind}
                    src={data?._user?.profilePicture || img_placehlder}
                    alt={`Member ${ind + 1}`}
                  />
                ))}
                {groupDetail?.members?.length > 3 && (
                  <img
                    src={grp_member5}
                    alt="More members"
                  />
                )}

                {groupDetail?.members?.length > 4 && (
                  <span className="more_member_add">
                    +{groupDetail?.members.length - 4}
                  </span>
                )}

                <div className="members-info">
                  <b>Members</b> ·{" "}
                  {groupDetail?.type === "PUBLIC"
                    ? "Public"
                    : groupDetail?.type === "PRIVATE"
                      ? "Private"
                      : "Subscription"}{" "}
                  Group
                </div>
              </div>

              <div className="button_wrap">
                {groupDetail?.request && Object.keys(groupDetail?.request).length > 0 ? (
                  renderHtml(groupDetail?.request?.status, groupDetail?.chat?._id)
                ) : (
                  groupDetail?.type === 'SUBSCRIPTION' && groupDetail?.subscription?.status !== 'ACTIVE' ? (
                    <Button onClick={() => setSubscriptionModal(true)} type="button" className="share_icon">
                      Subscribe
                    </Button>
                  ) : (
                    <LoadingButton
                      loading={joinLoading}
                      className="join_button"
                      onClick={(e) => {
                        // setGroupId(data?._id);
                        joinGroupHandler(groupDetail?._id);
                        e.preventDefault();
                      }}
                    >
                      Join
                    </LoadingButton>
                  )
                )}
                {(groupDetail?.admin?._user === showAuth?._id ||
                  groupDetail?.members?.some(member => member?._user?._id === showAuth?._id)) && (
                    <button
                      type="button"
                      className="video_member"
                      onClick={liveHandler}
                    >
                      <IoVideocamOutline />
                      &nbsp; Go Live
                    </button>
                  )}

              </div>
            </div>

            <div className="description">
              {groupDetail?.description || "---"}
            </div>
          </div>
          <div className="tabber">
            <ul className="tab_button">
              {groupKey?.map((data, ind) => (
                <li key={ind}
                  onClick={() =>
                    tabHandler("key", data?.value, searchParam, setSearchParam)
                  }
                  className={key === data?.value ? "active" : ""}
                >
                  {data?.name}
                </li>
              ))}
            </ul>

            <div className="tab_content">
              {key === "feed" && <Feeds groupId={groupId} groupDetail={groupDetail} showAuth={showAuth} />}

              {key === "connected" && <ConnectedGroup groupId={groupId} />}
            </div>
          </div>

          <DeleteModal
            show={deleteModal}
            handleClose={() => setDeleteModal(false)}
            deleteAccountHandler={deleteGroupHandler}
            loading={loading}
            text="Are you sure you want to delete this group"
          />
          {/* Group Member List */}
          {joinGroupRequestModal && (
            <GroupMemberList
              joinGroupRequestModal={joinGroupRequestModal}
              setJoinGroupRequestModal={setJoinGroupRequestModal}
              groupId={groupId}
              listing={getGroupDetail}
              newRequest={newRequest}
              groupDetail={groupDetail}
            />
          )}
          {groupSettingModal && (
            <GroupSetting
              setGroupDetail={setGroupDetail}
              groupDetail={groupDetail}
              groupSettingModal={groupSettingModal}
              setGroupSettingModal={setGroupSettingModal}
              listing={getGroupDetail}
            />
          )}
          {showReportModal && (
            <ReportSideDrawer
              showDrawer={showReportModal}
              setShowDrawer={setShowReportModal}
              reportId={groupId}
              type={"GROUP"}

            />
          )}
          {/* //----------Subscription-Plan------------------ */}
          <SubscriptionPlan
            show={subscriptionModal}
            close={() => setSubscriptionModal(false)}
            id={groupId}
            listing={getGroupDetail}
          />
          {/* ---------group-exit--------------- */}
          <ExitGroup
            show={exitGroupModal}
            close={() => setExitGroupModal(false)}
            memberId={null}
            memberApi={null}
            groupId={groupId}
            type='SELF'
            groupName={groupDetail?.name}
            detailAPi={getGroupDetail}
          />
        </div>
      </div >
    </>
  );
};

export default GroupsDetail;
